import { Component, OnInit, ViewEncapsulation, Input, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-reactions-summary',
  templateUrl: './reactions-summary.component.html',
  styleUrls: ['./reactions-summary.component.scss'],
  encapsulation: ViewEncapsulation.Emulated
})
export class ReactionsSummaryComponent implements OnInit {

  @Input() reactions: Map<string, []>;
  @Input() id: string;
  @Output() reactionsSummary: EventEmitter<any> = new EventEmitter();

  reactionsCount: Number = 0;

  constructor() { }

  ngOnInit() {
    this.getReactionsCount();
  }

  getReactionsCount() {
    for (let [key, value] of Object.entries(this.reactions)) {
      this.reactionsCount = this.reactionsCount + value.length;
    }
  }

  onReactionsSummary() {
    this.reactionsSummary.emit(this.id);
  }

}
